import { faMinus, faPlus } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Button from 'components/base/Button';
import {
  ChangeEvent,
  Dispatch,
  InputHTMLAttributes,
  SetStateAction
} from 'react';

interface QuantityButtonsProps {
  type?: 'default' | 'secondary';
  quantity: number;
  inputProps?: InputHTMLAttributes<HTMLInputElement>;
  setQuantity: Dispatch<SetStateAction<number>> | ((quantity: number) => void);
  disabled?: boolean;
}

const QuantityButtons = ({
  type = 'default',
  quantity,
  setQuantity,
  inputProps,
  disabled
}: QuantityButtonsProps) => {
  const handleIncrease = () => {
    setQuantity(quantity + 1);
  };

  const handleDecrease = () => {
    if (quantity > 1) {
      setQuantity(quantity - 1);
    }
  };

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    setQuantity(Number(e.target.value));
  };

  if (type === 'default') {
    return (
      <div className="d-flex flex-between-center">
        <Button
          variant="phoenix-primary"
          className="px-3"
          onClick={handleDecrease}
          disabled={disabled}
        >
          <FontAwesomeIcon icon={faMinus} />
        </Button>
        <input
          type="number"
          className="form-control text-center input-spin-none bg-transparent border-0 outline-none"
          style={{ width: 50 }}
          min="1"
          value={quantity}
          onChange={handleChange}
          {...inputProps}
          disabled={disabled}
        />
        <Button
          variant="phoenix-primary"
          className="px-3"
          onClick={handleIncrease}
          disabled={disabled}
        >
          <FontAwesomeIcon icon={faPlus} />
        </Button>
      </div>
    );
  }
  return (
    <div className="input-group input-group-sm flex-nowrap">
      <Button
        size="sm"
        className="px-2"
        onClick={handleDecrease}
        disabled={disabled}
      >
        -
      </Button>
      <input
        className="form-control text-center input-spin-none bg-transparent border-0 px-0"
        type="number"
        min={1}
        value={quantity}
        onChange={handleChange}
        {...inputProps}
        disabled={disabled}
      />
      <Button
        size="sm"
        className="px-2"
        onClick={handleIncrease}
        disabled={disabled}
      >
        +
      </Button>
    </div>
  );
};

export default QuantityButtons;
